import { StreamPlainObject } from './stream.plainObject';
import { PartitionPlainObject } from './partition.plainObject';

export class TransformPlainObject {
    public name: string;
    public configs: Map<string, string> = new Map<string, string>();
    public inputStreams: StreamPlainObject[] = [];
    public outputStreams: StreamPlainObject[] = [];
    public partition: PartitionPlainObject;

    constructor(public modelName: string) {
    }
}
